import { render, staticRenderFns } from "./ResourceTable.vue?vue&type=template&id=5cb30e17&"
import script from "./ResourceTable.vue?vue&type=script&lang=js&"
export * from "./ResourceTable.vue?vue&type=script&lang=js&"
import style0 from "./ResourceTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports